// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ScrollIndicator } from "@guestsupply/App/Components/Common/FancyScroll";
import { productListFilterAccordionSectionStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import Search from "@guestsupply/XDL/Icons/Search";
import { styledScrollbar } from "@guestsupply/XDL/Utilities";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            padding-bottom: 12px;
            margin-bottom: 0;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        & > ${TypographyStyle} {
            /* reset checkbox group mobius from 10 to 5 in this component only */
            &:first-child {
                margin-bottom: 5px;
            }
            &:last-child {
                margin-top: 5px;
            }
        }
    `,
};
productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        width: 100%;
        label {
            width: 100%;
            line-height: 13px;
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
            line-height: 13px;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBoxSelected = {
    ...productListFilterAccordionSectionStyles.checkBox,
    typographyProps: {
        ...productListFilterAccordionSectionStyles.checkBox.typographyProps,
        weight: "bold",
    },
};
productListFilterAccordionSectionStyles.seeAllLink = {
    css: css`
        padding-top: 5px;
    `,
};
productListFilterAccordionSectionStyles.seeLessLink = {
    css: css`
        padding-top: 5px;
    `,
};
productListFilterAccordionSectionStyles.facetWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};
productListFilterAccordionSectionStyles.searchTextField = {
    iconProps: {
        src: Search,
        size: 13,
        css: css`
            &&& {
                height: 24px;
                display: flex;
                justify-content: center;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 4px;
            margin-bottom: 8px;
        `,
        inputSelect: css`
            height: 28px;
        `,
    },
};
productListFilterAccordionSectionStyles.limitedFacetsWrapper = {
    css: css`
        position: relative;
        max-height: 150px;
        overflow-x: hidden;
        padding: 2px 4px 2px 0;
        width: calc(100% - 4px); /* remove scollbar width */
        ${styledScrollbar(4, 0)}

        @supports (-moz-appearance:none) {  /* increase padding for firefox */
            padding: 2px 13px 2px 0;
        }
    `,
};
productListFilterAccordionSectionStyles.facetNameTypography = {
    weight: 400,
    css: css`
        flex: 1;
        padding-right: 4px;
        word-break: break-word;
        overflow-wrap: break-word;
    `,
};

productListFilterAccordionSectionStyles.facetsScrollWrapper = {
    css: css`
        ${ScrollIndicator} {
            height: 12px;
        }
    `,
};

productListFilterAccordionSectionStyles.categoryParentsypography = {
    weight: 400,
    css: css`
        font-size: 10px;
        font-style: italic;
    `,
};
